import axios, { AxiosError, AxiosResponse } from "axios";
import { GlobalOperations } from "../config/GlobalApiOperations";
import { ApiBaseResponse } from "../models/Common/ApiBaseResponse";

// TODO: Error text silinecek bu işlem yalnızca ui kısmında kullanılacak
// Yardımcı fonksiyon: data.text varsa döner
const getErrorText = (data: ApiBaseResponse<null>): string | null => {
  return data.text;
};

// Merkezi API istemcisi
const api = axios.create({
  baseURL: GlobalOperations.BaseUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// İstek interceptor'ı
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error),
);

// Yanıt interceptor'ı
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response) {
      const { status, data } = error.response;
      const errorText = getErrorText(data as ApiBaseResponse<null>);

      // Önce errorText varsa göster, yoksa duruma göre default mesajı göster
      switch (status) {
        case 400:
          console.error("400 - Geçersiz İstek!");
          break;
        case 401:
          console.error("401 - Yetkisiz Erişim!");
          if (window.location.pathname !== "/tr-TR/AgencyLogin") {
            // toast.error(errorText ?? "Yetkiniz yok. Giriş yapın.");
            setTimeout(() => {
              window.location.href = "/tr-TR/AgencyLogin";
            }, 1000);
          }
          break;
        case 403:
          console.error("403 - Erişim Engellendi!");
          // toast.error(errorText ?? "Bu işlemi yapmaya yetkiniz yok.");
          break;
        case 404:
          console.error("404 - Method Bulunamadı!");
          // toast.error(errorText ?? "Aradığınız içerik bulunamadı.");
          break;
        case 500:
          console.error("500 - Sunucu Hatası!");
          // toast.error(errorText ?? "Sunucu hatası oluştu. Daha sonra tekrar deneyin.");
          break;
        default:
          console.error(`${status} - Bilinmeyen Hata`);
          // toast.error(errorText ?? "Bilinmeyen bir hata oluştu.");
      }
    } else {
      console.error("Bağlantı hatası:", error.message);
      // toast.error("Sunucuya ulaşılamıyor. İnternet bağlantınızı kontrol edin.");
    }

    return Promise.reject(error);
  },
);

export default api;
